import * as React from 'react';
import TextField from "@material-ui/core/TextField";
import Translate from '../../common/functions/translate';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import * as HelperFunctions from '../../common/functions/helperFunctions';
import blue from '@material-ui/core/colors/blue';
import { ActiveFilterType } from '../../common/enums';
import { ProductFilterSettingsModel } from '../../models/product/productFilterSettingsModel';
import CategoryService from '../../services/categoriesService';
import Button from "@material-ui/core/Button";
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import { DropdownModel } from '../../models/dropdownModel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faTimes } from '@fortawesome/free-solid-svg-icons';
import Paper from '@material-ui/core/Paper';

interface IProps {
  onSearchClick: any,
  totalRecordsCount: number,
  productSettings: ProductFilterSettingsModel,
  //categoryFilterLabel: string
}

interface IState {
  filterText: string;
  currentProductSettings: ProductFilterSettingsModel;
  actives: Array<DropdownModel>;
}

const theme = createMuiTheme({
  overrides: {
    MuiFormControl: {
      root: {
        width: 200
      }
    }
  },
  palette: {
    primary: blue
  }
});

export class ProductFilter extends React.Component<IProps, IState>  {
  categoryService = new CategoryService();

  constructor(props) {
    super(props);
    this.state = {
      currentProductSettings: this.props.productSettings ? this.props.productSettings : new ProductFilterSettingsModel(),
      actives: new Array<DropdownModel>(),
      filterText: ''
    };
  }

  componentDidMount() {
    this.setState({ actives: new Array<DropdownModel>().concat(HelperFunctions.enumToDropdownArray(ActiveFilterType, true)) });
  }

  componentDidUpdate(prevProps) {
    if (this.props.productSettings !== prevProps.productSettings) {
      const filterText = this.generateFilterText(this.props.productSettings);
      this.setState({ currentProductSettings: this.props.productSettings, filterText: filterText, });
    }
  }

  handleChange = (key, value) => {
    let settings = { ...this.state.currentProductSettings };

    settings[key] = value;

    const filterText = this.generateFilterText(settings);

    this.setState({
      currentProductSettings: settings,
      filterText: filterText,
    });
  };

  generateFilterText = (settings: ProductFilterSettingsModel) => {
    let result = '';

    for (let setting in settings) {
      if (setting !== 'actives' && settings[setting] !== undefined)
        result += Translate(setting.charAt(0).toUpperCase() + setting.slice(1)) + " <strong>'" + settings[setting] + "'</strong>, ";

      if (setting === 'actives' && settings[setting] !== undefined)
        result += Translate(setting.charAt(0).toUpperCase() + setting.slice(1)) + " <strong>'" +
          HelperFunctions.getEnumLabel(settings[setting], ActiveFilterType, true) + "'</strong>, ";
    }

    return result.substr(0, result.length - 2);
  }

  handleSearchButtonClick = () => {
    this.props.onSearchClick(this.state.currentProductSettings);
  }

  handleClearButtonClick = () => {
    let newSettings = new ProductFilterSettingsModel();
    newSettings.actives = ActiveFilterType.All;
    this.setState({
      currentProductSettings: newSettings,
      filterText: '',
    });

    this.props.onSearchClick(newSettings);
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearchButtonClick();
    }
  }

  render() {
    let { filterText, currentProductSettings, actives } = this.state;

    return (
      <Paper style={{ padding: 10, marginBottom: 15, backgroundColor: "#f5f5f5" }} >
        <div>
          <MuiThemeProvider theme={theme}>
            <TextField
              onKeyPress={(e) => this.handleKeyPress(e)}
              name="articleNumber"
              label={Translate("Article number")}
              style={{ marginRight: 10 }}
              type="text"
              onChange={(e) => this.handleChange('articleNumber', e.target['value'])}
              value={currentProductSettings.articleNumber || ''}
            />
            <TextField
              onKeyPress={(e) => this.handleKeyPress(e)}
              name="article"
              type="text"
              style={{ marginRight: 10 }}
              label={Translate("Article")}
              onChange={(e) => this.handleChange('article', e.target['value'])}
              value={currentProductSettings.article || ''}
            />
            <TextField
              onKeyPress={(e) => this.handleKeyPress(e)}
              name="brand"
              type="text"
              style={{ marginRight: 10 }}
              label={Translate("Brand")}
              onChange={(e) => this.handleChange('brand', e.target['value'])}
              value={currentProductSettings.brand || ''}
            />
            <TextField
              onKeyPress={(e) => this.handleKeyPress(e)}
              name="power"
              type="text"
              style={{ marginRight: 10 }}
              label={Translate("Power")}
              onChange={(e) => this.handleChange('power', e.target['value'])}
              value={currentProductSettings.power || ""}
            />

            <TextField
              onKeyPress={(e) => this.handleKeyPress(e)}
              name="supplier"
              type="text"
              style={{ marginRight: 10 }}
              label={Translate("Supplier")}
              onChange={(e) => this.handleChange('supplier', e.target['value'])}
              value={currentProductSettings.supplier || ""}
            />
            <FormControl>
              <InputLabel htmlFor="active-label">{Translate('Active')}</InputLabel>
              <Select
                name="activeId"
                value={currentProductSettings.actives ? currentProductSettings.actives : ''}
                onChange={(e) => this.handleChange('actives', e.target.value)}
                inputProps={{
                  id: 'active-label'
                }}
              >
                {
                  actives.map(m => <MenuItem key={m.value + 'active'} value={m.value}> {m.value ? m.label : <em>{m.label}</em>}</MenuItem>)
                }
              </Select>
            </FormControl>
          </MuiThemeProvider>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 5 }}>
          <div style={{ fontSize: "0.9em" }}>
            {Translate('Result')}: <strong>{this.props.totalRecordsCount}</strong>
            {filterText ? ', ' : ''}
            <span dangerouslySetInnerHTML={{ __html: filterText }}></span>
          </div>
          <div>
            <Button
              color="primary"
              variant="contained"
              style={{ marginRight: 10 }}
              size="small"
              onClick={() => this.handleSearchButtonClick()}
            >
              <FontAwesomeIcon icon={faFilter} style={{ marginRight: 10 }} />
              {Translate("Filter")}
            </Button>
            <Button
              variant="contained"
              size="small"
              onClick={() => this.handleClearButtonClick()}>
              <FontAwesomeIcon icon={faTimes} style={{ marginRight: 10 }} />
              {Translate("Clear")}
            </Button>
          </div>
        </div>
      </Paper>
    )
  }
}

export default ProductFilter;
